var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"revit-element-subelements-tab"},[_c('a-row',[_c('a-col',{attrs:{"span":24}},[_c('label',[_vm._v("Subelementen")]),_c('br'),_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.currentItem.subelements,"rowKey":"id","scroll":{ x: true },"pagination":false}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }